<template>
  <section>
    <HeaderBar />

    <VerticalNavMenu />

    <v-main class="grey lighten-4">
      <div class="my-15">
        <v-slide-x-transition mode="out-in">
          <router-view
            v-if="
              $store.state.auth.navMenuList &&
              $store.getters['auth/hasMenuAccess']($route.path) === true
            "
          />
          <Page403 v-else />
        </v-slide-x-transition>
      </div>
      <Footer />
    </v-main>
    <v-overlay :value="$store.state.pageDisabled" z-index="9999">
      <v-progress-circular :size="70" :width="7" color="grey" indeterminate></v-progress-circular>
    </v-overlay>

    <LoginSessionExpirationDialog />

    <StatusDialog />
    <StatusSnackbar />
    <PdfDialog />
  </section>
</template>

<script>
  import LoginSessionExpirationDialog from '@/components/LoginSessionExpirationDialog.vue';
  import StatusDialog from '@/components/StatusDialog.vue';
  import StatusSnackbar from '@/components/StatusSnackbar.vue';
  import PdfDialog from '@/components/PdfDialog.vue';
  import VerticalNavMenu from './components/VerticalNavMenu.vue';
  import HeaderBar from './components/HeaderBar.vue';
  import Footer from './components/Footer.vue';
  import Page403 from '../pages/error/Page403.vue';

  export default {
    components: {
      LoginSessionExpirationDialog,
      StatusDialog,
      StatusSnackbar,
      PdfDialog,
      VerticalNavMenu,
      HeaderBar,
      Footer,
      Page403,
    },
    created() {
      this.$store.dispatch('auth/getUserProfileList');
      this.$store.dispatch('auth/getNavMenuList');
      if (this.$store.state.mstCodeEnums.length < 1) {
        this.$store
          .dispatch('lookUpApi/getHashTableMstCode')
          .then((resp) => {
            this.$store.commit('setMstCodeEnums', resp);
          })
          .catch(() => []);
      }
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style src="@/styles/AuthUserLayout.scss" lang="scss" />
